import 'ant-design-vue/dist/antd.min.css';
import 'element-plus/dist/index.css';

import '@kunlun/vue-ui-antd/dist/kunlun-vue-ui-antd.css';
import '@kunlun/vue-ui-el/dist/kunlun-vue-ui-el.css';
import './style.scss';

import 'reflect-metadata';
import {
  Dialog,
  IResponseErrorResult,
  MessageHub,
  OioLoginLogoPosition,
  OioLoginThemeName,
  registerMask,
  registerTheme,
  ReturnPromise,
  VueOioProvider
} from '@kunlun/dependencies';
// import './version/check';

import './mask';
import './field';
import './view';
import './actions';
import './custom-widget';

import './util/common.scss';
import { themeCssVars, themeName } from './theme';

registerTheme(themeName, themeCssVars);

// <widget widget="language" />
// <widget widget="divider" />
// <widget widget="notification" />
// <widget widget="divider" />

registerMask(
  `
    <mask>
      <header>
        <widget widget="app-switcher" />
        <block>
          <widget widget="MobileMall" />
          <widget widget="divider" />
          <widget widget="PCMall" />
          <widget widget="divider" />
          <widget widget="PCNotice" />
          <widget widget="divider" />
          <widget widget="merchantUser" />
          <widget widget="divider" />
          <widget widget="user" />
          <widget widget="NoticeWidget" />
        </block>
      </header>
      <container>
        <sidebar>
          <widget widget="nav-menu" height="100%" />
        </sidebar>
        <block height="100%" flex="1 0 0" flexDirection="column" alignContent="flex-start" flexWrap="nowrap" overflow="hidden">
          <multi-tabs inline="true" />
          <content>
            <breadcrumb />
            <block width="100%">
              <widget width="100%" widget="main-view" />
            </block>
          </content>
        </block>
      </container>
    </mask>
  `
);

VueOioProvider(
  {
    http: {
      url: location.origin,
      // callback: interceptor
      interceptor: {
        networkError: {
          error(response: IResponseErrorResult): ReturnPromise<boolean> {
            const { networkError, errors } = response;
            const errorCode = errors?.[0]?.extensions?.errorCode;

            const CHANGE_PWD_ERRORCODE = '50070065';
            const MODULE_NO_AUTH_ERRORCODE = '11040035';

            if (errorCode == CHANGE_PWD_ERRORCODE) {
              location.href = '/first';
              return false;
            }

            if (errorCode == MODULE_NO_AUTH_ERRORCODE) {
              location.href = '/';
              return false;
            }

            if (networkError) {
              const { bodyText, name, message } = networkError;
              if (name && message) {
                if (!/Time\-out|timeout/i.test(bodyText)) {
                  MessageHub.error(message);
                } else {
                  Dialog.dispose();
                }
              }
              return false;
            }
            return true;
          }
        },
        requestError: {
          error(response: IResponseErrorResult): ReturnPromise<boolean> {
            const { errors } = response;
            if (errors?.length) {
              if (errors[0]?.message?.includes('deliAriesActivityItemTplDetailQuery/formTableImportWidgetV2Validate')) {
                MessageHub.error('excel数据格式错误，请检查excel数据。');
                return true;
              }
              MessageHub.error(errors[0].message || errors[0]?.extensions?.messages?.[0]?.message);
            }
            return true;
          }
        }
      }
    },
    browser: {
      title: 'deli-dms'
      // favicon: 'https://fxit-dhb-tjb.oss-cn-hangzhou.aliyuncs.com/deli-b2b/image/favicon.jpg'
    },
    theme: [themeName],
    loginTheme: {
      backgroundImage: '',
      backgroundColor: '#f5f5f5',
      logoPosition: OioLoginLogoPosition.CENTER,
      name: OioLoginThemeName.CENTER_STICK
    },
    dependencies: {
      vue: import('vue'),
      lodashEs: import('lodash-es'),
      antDesignVue: import('ant-design-vue'),
      elementPlusIconsVue: import('@element-plus/icons-vue'),
      elementPlus: import('element-plus'),
      kunlunDependencies: import('@kunlun/dependencies'),
      kunlunVueUiAntd: import('@kunlun/vue-ui-antd'),
      kunlunVueUiEl: import('@kunlun/vue-ui-el'),
      xlsx: import('xlsx'),
      fileSaver: import('file-saver'),
      Decimal: import('decimal.js')
    }
  },
  []
);
